import React, { useMemo } from 'react';
import { useTranslation } from '@lib/useTypedTranslation';
import * as am4charts from '@amcharts/amcharts4/charts';

import { IAccessPointSignalLevelTrend } from '../../../../services/core/accessPoints';
import { Tooltip } from '../../../../components/tooltip/tooltip';
import { StackedColumnsDateChart } from '@components/chart/stackedColumnsDateChart';
import { drawAccessPointSamplesXAxisLabels, formatTooltipHour } from './coreAccessPointSamples';
import { DateRange } from '..';
import './charts.css';

interface IProps {
  data: IAccessPointSignalLevelTrend[],
  dateRange: DateRange,
  onMount: (chart: am4charts.XYChart) => am4charts.XYChart
}

export const CoreAccessPointScore = (props: IProps) => {
  const { data, dateRange } = props;
  const { t } = useTranslation('coreAccessPoints');
  const scoreData = useMemo(() => data.some(d => d.score !== null) ? data : [], [data]);

  return (
    <div className="core-access-point-chart-section">
      <StackedColumnsDateChart<IAccessPointSignalLevelTrend>
        data={scoreData}
        className="core-ap-score-by-time-chart"
        series={[{
          dataKey: 'score',
          description: t('PERFORMANCE_SCORE'),
          visible: true,
          colour: '#5b9ad2',
        }]}
        title={
          <>
            {t('PERFORMANCE_SCORE_BY_TIME')}{' '}
            <Tooltip popperContent={t('PERFORMANCE_SCORE_BY_TIME_TOOLTIP')} placement="right">
              <i className="fa fa-question-circle" style={{ color: '#7490b9', cursor: 'pointer' }} />
            </Tooltip>
          </>
        }
        columnWidth={10}
        onMount={props.onMount}
        days={30}
        xAxisType={'date'}
        yAxisType={'value'}
        formatTooltipDate={formatTooltipHour}
        cypressId={'coreAccessPointScoreByTime'}
        hasLegend={true}
        drawXAxis={(_, xAxis) => drawAccessPointSamplesXAxisLabels(xAxis as am4charts.DateAxis, dateRange)}
        drawYAxis={(_, axis) => {
          const valueAxis = axis as am4charts.ValueAxis;
          valueAxis.min = 0;
          valueAxis.max = 100;
          valueAxis.strictMinMax = true;
        }}
        useAxisTooltip
        bottomBorder
      />
    </div>
  );
};
